<!-- Tutor shell: menu column left, content card right; the four tabs of
     "Verhalten & Fähigkeiten" inside the card. -->
<app-tutor-menu>
  <nb-card class="setup-card">
    <nb-card-body>
      <nb-tabset *ngIf="ready" routeParam="tab" (changeTab)="onTabChange($event)">
        <nb-tab
          *ngFor="let tab of tabs; trackBy: trackTab"
          [tabId]="tab.key"
          [route]="tab.key"
          [tabTitle]="tab.titleKey | translate"
          [tabIcon]="tab.icon"
          [active]="tab.key === active"
          [lazyLoad]="true"
        >
          <ng-template nbTabTitle>
            <span class="tab-text" [alAnchor]="'tab.' + tab.key" [nbTooltip]="'pages.agentSetup.tabs.' + tab.key | translate">{{ tab.titleKey | translate }}</span>
          </ng-template>
          <ng-container [ngSwitch]="tab.key">
            <app-learnings *ngSwitchCase="'learnings'"></app-learnings>
            <app-tutor-skills *ngSwitchCase="'skills'"></app-tutor-skills>
            <app-tutor-mcp *ngSwitchCase="'mcp'"></app-tutor-mcp>
            <!-- Nur im offenen Reiter: nb-tab hält projizierten Inhalt trotz
                 lazyLoad am Leben, die KI-Konfiguration liefe sonst immer mit. -->
            <ng-container *ngSwitchCase="'moodle'">
              <app-ai-settings *ngIf="active === 'moodle'"></app-ai-settings>
            </ng-container>
            <app-guardrails *ngSwitchCase="'guardrails'" [embedded]="true"></app-guardrails>
          </ng-container>
        </nb-tab>
      </nb-tabset>
      <nb-spinner *ngIf="!ready" status="basic"></nb-spinner>
    </nb-card-body>
  </nb-card>
</app-tutor-menu>
